export default {
    // $ 公共
    general_button_cancel: '取消',
    general_button_sure: '确定',
    general_button_close: '关闭',
    general_text_update_faild: '更新失败',
    general_button_done: '完成',
    general_text_ordered: '已点',
    general_text_next_turn_time: '次轮',
    general_text_get_limit_rule_failed: '获取轮次规则失败',
    general_text_customer_not_exist: '用户{{n}}不存在',
    general_text_can_not_get_rules_of_dish: '无法获取菜品规则数据',
    general_text_no_data: '暂无数据',

    // $ 历史订单
    order_history_page_text_no_make: '尚未制作',
    order_history_page_text_make_complete: '制作完成',
    order_history_page_text_service_complete: '上菜完毕',
    order_history_page_text_unable_make: '无法制作',
    order_history_page_text_pause_make: '暂停制作',
    order_history_page_text_waiter: '服务员',
    order_history_page_text_customer: '顾客',
    order_history_page_text_extra: '额外费用',
    order_history_page_text_order_devices: '其他设备',
    history_order_you: '顾客',
    history_order_round: '第{{round}}轮',
    history_order_total: '共{{number}}道菜',

    // $ 呼叫服务
    service_page_text_call_service_select: '呼叫选项（非必填）',
    service_page_text_insert_texts: '请输入内容（非必填）',
    service_page_text_call_waiter: '呼叫服务员',
    service_page_text_call_service: '呼叫服务',
    service_page_text_table_name: '您的桌号',
    service_page_text_Please_select_a_service: '请选择一个服务',
    service_page_text_Your_requirement: '您的需求（可选）',
    service_page_text_call_service_success_message: '呼叫成功',
    service_page_input_placeholder_message: '输入您的需求...',

    // $ 购物车
    order_cart_page_text_total: '总额',
    order_cart_page_text_complete_order: '您已完成本轮次点餐',
    order_cart_page_text_round_max_order_count: '轮次最大点餐数量：{{n}}',
    order_cart_page_text_round_max_number_exceed: '超过轮次最大点餐数量',
    order_cart_page_text_similar_dish_number_exceed: '超过同类菜品限制数量',
    order_cart_page_text_same_dish_number_exceed: '该菜品已超出最大点餐数',
    order_cart_page_text_max_rounds_exceed: '超过最大回合数',
    order_cart_page_text_dish_not_exists: '菜品不存在',
    order_cart_page_text_commit_cart_fail: '购物车提交失败',
    order_cart_page_text_commit_success: '提交成功',
    order_cart_page_text_cart_not_data: '您的购物车无数据',
    order_cart_page_text_select_preferences: '点击菜名可以选择您的做法偏好',
    order_cart_page_text_disable_edit_second: '还有{{s}}秒进入下一轮, 菜品无法编辑',
    order_cart_page_text_print_credential_fail: '打印小票失败',
    order_cart_page_text_dish_remarks: '菜品备注',
    order_cart_page_text_self: '自己',
    order_cart_page_text_cannot_at_the_same_time: '请勿同时提交购物车或修改菜品',
    order_cart_page_text_is_submitting: '购物车正在提交...',
    order_cart_page_text_round_rules: '每轮次只能发送一次购物车，您的可点餐品数量未满，是否发送？',
    order_cart_page_text_clear: '清空',
    order_cart_page_text_delete: '删除',
    order_cart_page_text_exe_dishes_commit: '存在超额菜品,是否继续提交',
    order_cart_page_text_confirm_modification: '确认',
    order_cart_page_text_sync_round_info_success: '更新轮次信息成功',
    order_cart_page_text_dish_is_sold_out: '该菜品已沽清',
    order_cart_page_text_sold_out: '沽清',
    order_cart_Page_text_verify_sold_out_dishes_message: '菜品\'{{menuName}}\'可点数量为{{excessedNum}};',

    // $ 点餐
    menu_page_text_please_select_your_id: '请输入您的ID',
    menu_page_text_check_tip_id: '忘记ID?核对您上次的点餐记录来回忆',
    menu_page_text_dishes_copy: '{{n}}在本轮被点了{{1}}份',
    menu_page_text_more_than_half_ordered: '已有{{n}}人点了{{dish}}',
    menu_page_text_not_show: '不再显示此类信息',
    menu_page_text_under_review_wait: '审核中，请稍后',
    menu_page_text_order_success_created_jump: '订单创建成功, 跳转到菜单页面',
    menu_page_text_order_does_not_exist: '订单不存在或桌台被重置，请重新开台',
    menu_page_text_review_rejected: '审核被拒绝',
    menu_page_text_under_review: '审核中',
    menu_page_text_locked_state: '下单为锁定状态，您可以自由浏览',
    menu_page_text_reset_send: '重新发送审核',
    menu_page_text_reset_send_success: '重新发送成功',
    menu_page_text_approved: '审核通过',
    menu_page_text_order_unlocked: '下单已解锁',
    menu_page_text_table_invalid: '无效桌台',
    menu_page_text_customer_id_occupy: '您的id被占用',
    menu_page_text_dish_time_disable: '由于厨房已关闭，部分菜单已禁用',
    menu_page_text_notice_time: '厨房将于{{time}}分钟后关闭，请在厨房关闭前点完您的菜品',
    menu_page_text_allergen_filter_label_message: '选择需要被过滤的菜品',
    menu_page_text_allergen: '过敏原',
    menu_page_text_ingredents: '其他菜品标识',
    menu_page_text_ingredent_filter_label_message: '选择需要被过滤的菜品',
    menu_page_text_filter: '筛选',
    menu_page_text_dish_exceeded: '您正在添加的菜品已超过单品数量限制，继续添加可能会被额外收费',

    // $ 扫码入口页
    home_page_text_please_select_menu: '请选择菜单',
    home_page_text_number_of_adults: '成人人数',
    home_page_text_number_of_child: '未成年人人数',
    home_page_text_adult_price: '大人价格',
    home_page_text_child_price: '小孩价格',
    home_page_text_normal: '普通',
    home_page_text_special: '特殊',
    home_page_text_table_pause_use: '该桌台暂停使用',
    home_page_text_order_now: '立即点餐',
    home_page_text_get_menu_fail: '载入菜单失败，请重试',
    home_page_text_announcement: '公告',

    // $ 公告页
    notice_page_text_no_picture: '暂无图片',

    // $ 过敏源种类
    text_gluten: "麸质",
    text_crustaceans: "甲壳类",
    text_eggs: "蛋或籽",
    text_fish: "鱼类",
    text_peanuts: "花生",
    text_soya: "豆类",
    text_milk: "牛奶",
    text_tree_nuts: "坚果类",
    text_celery: "芹菜",
    text_mustard: "芥末",
    text_sesame: "芝麻",
    text_sulphites: "二氧化硫或亚硝酸盐",
    text_lupin: "羽扇豆",
    text_molluscs: "软体动物",
    text_mild_spicy: "微辣",
    text_medium_spicy: "中辣",
    text_very_spicy: "重辣",
    text_frozen_origin: "购买源速冻",
    text_blast_freezing: "预防性速冻",
    text_vegetarian: "素食",
    text_vegan: "纯素",
    text_gluten_free: "无麸质食品",
    text_raw: "含生配料",
    text_cooked: "熟食",
    text_additives: "食品添加剂",
    text_colourants: "食用色素",

    // 新手引导
    novice_guide_text_select_menu: '选择菜单',
    novice_guide_text_select_normal_menu: '选择标准菜单',
    novice_guide_text_select_special_menu: '选择特殊菜单',
    novice_guide_text_select_number_of: '选择人数',
    novice_guide_text_order: '点餐',
    novice_guide_text_announcement: '公告',
    novice_guide_text_cart: '购物车',
    novice_guide_text_history: '下单历史',
    novice_guide_text_call: '呼叫服务',
    novice_guide_text_switch_dish_mode: '切换菜品显示模式',
    novice_guide_text_first_menu: '选择一级菜单',
    novice_guide_text_switch_user: '显示当前用户',
    novice_guide_text_round_dish: '查看点餐轮数',
    novice_guide_text_click_dish_card_add: '点击此区域下单菜品',
    novice_guide_text_click_dish_card_reduce: '点击此区域减少菜品',
    novice_guide_text_enlarge_dish_card: '点击此区域查看菜品详情',
    novice_guide_text_click_cancel: '单击取消新手引导',
    novice_guide_text_reduce_order: '减少数量',
    novice_guide_text_increase_order: '增加数量',
    novice_guide_text_table: '桌号',
    novice_guide_text_enter_number: '输入人数',
    novice_guide_text_swipe_to_switch: '滑动切换',
    novice_guide_text_home: '主页',

    // 自助开台
    auto_open_page_text_featured_dishes: '特色菜品',
    auto_open_page_text_order_now: '立即点餐',
    auto_open_page_text_opening_hours: '点餐可用时间',
    auto_open_page_text_media: '社交媒体',
    auto_open_page_text_website: '官方网站',
    auto_open_page_text_reservation: '在线订位',
    auto_open_page_text_takeaway: '外卖',
    auto_open_page_text_without_menu: '当前时间没有可选的菜单',
    auto_open_page_adults: '成人',
    auto_open_page_children: '小孩',
    auto_open_page_other: '其他',
    auto_open_page_text_menu: '菜单',
    text_persons: '人数',
    auto_open_page_open_table: '开桌信息',
    auto_open_page_select: '选择',
    auto_open_page_see_more: '查看更多',
    auto_open_page_text_disabled_message: '自助开桌已禁用,请联系服务员',

    // 临时密码功能
    auto_open_page_text_set_temporary_password: '创建临时密码',
    auto_open_page_text_input_temporary_password: '请输入临时密码',
    auto_open_page_text_reset_temporary_password: '重置临时密码',
    auto_open_page_text_cancel_temporary_password: '废除临时密码',
    auto_open_page_text_forgot_password: '忘记密码',
    auto_open_page_text_input_password: '请输入4位数字密码',
    auto_open_page_text_go_back: '返回',
    auto_open_page_text_confirm_changes: '确认修改',
    auto_open_page_button_confirm: '确认',
    auto_open_page_employee_account: '员工账号',
    auto_open_page_employee_password: '员工密码',
    auto_open_page_incorrect_pin: '密码错误',
    auto_open_page_modification_failed: '修改失败',
    auto_open_page_modification_succeed: '修改成功',
    auto_open_page_pin: '临时密码',

    // 复合型营业时间
    general_text_all_day_business: '24小时营业',
    general_text_business_hours: "固定营业时间",
    general_text_compound_business_hours: "周期性营业时间",

    // 餐厅区域
    general_text_You_are_not_in_the_restaurant_area_unable_to_order: '您不在餐厅区域内，无法点餐',
    general_text_Getting_your_location_failed: '获取您的位置信息失败',

    general_text_poor_network: '网络不佳或连不上服务器，请稍后再试',

    // 点餐 - 套餐相关
    menu_page_text_setMenu: '套餐',
    menu_page_text_choose_the_products: '选择商品',
    menu_page_text_add_to_cart: '添加到购物车',
    menu_page_text_set_menu_required: '必选',
}